// Aligned with interview plan Details (schedule-interview)
export const INTERVIEW_TYPE_OPTIONS = [
  { label: 'One-on-one interview', value: 'one_on_one' },
  { label: 'Panel interview', value: 'panel' },
];

export const SCHEDULE_AI_COPY = {
  title: 'Schedule with AI',
  timingLabel: 'When should we call?',
  contextTemplateLabel: 'Context template',
  addContextTemplate: 'Add context template',
  interviewDetailsLabel: 'Interview details',
  editInterview: 'Edit interview',
  interviewer: 'Interviewer',
  duration: 'Duration',
  location: 'Location',
  sendSchedule: 'Send schedule',
  callNow: 'Call now',
  scheduleCall: 'Schedule call',
  cancel: 'Cancel',
  back: 'Back',
  setSchedule: 'Set schedule',
  /** Shown in timing KSelect when custom date/time is chosen (before the formatted instant). */
  timingCustomDateSelectedPrefix: 'Custom date',
  time: 'Time',
  candidateTimezone: "Candidate's timezone",
  currentTimeForCandidate: 'Current time for candidate',
  candidateTimezoneMissing:
    'Please add a timezone to the candidate profile to schedule accurately.',
  customScheduleInPast:
    'That time is already in the past for this candidate. Pick a future date and time.',
  enableNoteTaker: 'Enable AI notetaker?',
  enableNoteTakerDescription:
    'The AI Notetaker automatically captures key points and summaries during meetings. It organizes and highlights information for easy review and follow-up.',
  makeInterviewPrivate: 'Make the interview private',
  hideCalendarFromNonAttendees:
    'Hide calendar event details from non-attendees',
  rescheduleReasonLabel: 'Reason for rescheduling',
  rescheduleReasonPlaceholder:
    "Add context for the coordinator so the candidate knows why you're rescheduling",
  additionalContextLabel: 'Additional context for the agent',
  additionalContextDescription:
    'You can add additional context to help the agent with all the info it needs.',
  additionalContextPlaceholder: 'Write your additional context here',
  submitValidationPlanLoading: 'Please wait for the interview plan to load.',
  submitValidationDateTime: 'Please select when to send the schedule.',
  submitValidationLocation: 'Please select a meeting location.',
  submitValidationOffice: 'Please select an office address.',
  submitValidationInterviewers: 'Please add at least one interviewer.',
  calendarNotConnectedTooltip: 'Calendar not connected. Events not visible.',
  checkingCalendars: 'Checking calendars...',
  scheduling: 'Scheduling...',
};
